module.exports = __webpack_public_path__ + "img/GH-kyujin-top-044.252b19b8.webp";